import React, { useEffect, useRef, useState } from "react";
import ESignStyles from "./AccountClosureEsign.module.scss";
import { LoadingButton } from "@mui/lab";
import SnackBar from "../../Components/SnackBars/SnackBar";
import esignImage from "../../Components/assets/Images/Account Closure Request Form_page-0001.jpg";
import { Button, Stack, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  CreateEsignConsentAccountClosureAPICall,
  RequestEsignAPICall,
  stageDetailsAPICall,
} from "./APICallsAccountClosure";
import ErrorSnackBar from "../../Components/SnackBars/ErrorSnackBar";
import backicon from "../../Components/assets/Images/back.svg";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import keyboardicon from "../../Components/assets/Images/esignicongrey.svg";
import PDFViewerIframeEsign from "../../Components/PDFIframe/PDFIframeEsign";
import { REDIRECTURL } from "../../shared/constants";

function AccountClosureEsign() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [childWindowRef, setchildWindowRef] = useState<any>(null);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [pdfUrl, setPdfUrl] = useState<any>("");
  const [showModal, setshowModal] = useState(false);
  const [pdf, setpdf] = useState("");
  const timerRef = useRef<any>(null);
  const [continueOption, setcontinueOption] = useState(true);
  const [startloading, setstartloading] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [accountClosureReason, setAccountClosureReason] = useState("");
  const requestID: any = sessionStorage.getItem("acrequestID");
  const [esignLoading, setEsignLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    StageDetails();
  }, []);

  const FillEsignPdf = () => {
    let obj: any = {
      req_id: requestID,
      reason_for_closure: accountClosureReason,
    };
    setloading(true);
    RequestEsignAPICall(obj)
      .then((response: any) => {
        // console.log("response", response);
        setloading(false);
        // setpdf(response.data.data.url);
        setPdfUrl(response.data.data.url);
        setshowModal(true);
        // setloading(false);
      })
      .catch((error: any) => {
        // setloading(false);
        setloading(false);
      });
  };

  useEffect(() => {
    if (childWindowRef) {
      timerRef.current = setInterval(checkChild, 500);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [childWindowRef]);

  useEffect(() => {
    if (startloading) {
      setloading(true);
      if (pdfUrl) {
        setshowModal(true);
        setloading(false);
        setstartloading(false);
      }
    }
  }, [pdfUrl, startloading]);

  function checkChild() {
    if (childWindowRef && childWindowRef.closed) {
      clearInterval(timerRef.current);
      setloading(false);

      StageDetails();
    }
  }
  const StageDetails = () => {
    let obj: any = {
      stage: "esign",
      request_id: requestID,
    };
    setloading(true);
    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        setloading(false);

        if (responseData.data.ErrMessage) {
          setRejectMessage(responseData.data.ErrMessage);
        }
        if (responseData.data.closure_reason) {
          setAccountClosureReason(responseData.data.closure_reason);
        }

        if (responseData.data.url !== "") {
          navigate(`/account_closure/completed`);
        }
      })
      .catch((error: any) => {
        setloading(false);
      });
  };

  const openHtmlPage = (htmlString: string) => {
    const blob = new Blob([htmlString], { type: "text/html" });
    const url = URL.createObjectURL(blob);

    window.location.href = url;
  };

  const handleOpenClick = () => {
    setloading(true);
    let digilink: string = "";

    let obj: any = {
      request_id: requestID,
      callback_url: `${REDIRECTURL}account_closure/esignResponse`,
    };
    setEsignLoading(true);
    CreateEsignConsentAccountClosureAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("link", response.data);

        var url = responseData.data.esp_html;
        var trimmedUrl = url.replace(":444", "");
        digilink = url;
        openHtmlPage(digilink);
        setEsignLoading(false);
        // setTimeout(() => {
        //   const childWindow: any = window.open(
        //     digilink,
        //     "_blank",
        //     "width=500,height=700"
        //   );
        //   setchildWindowRef(childWindow);
        // });
      })
      .catch((error: any) => {
        setloading(false);
        setEsignLoading(false);
        setErrorMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message,
        );
        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
      });
  };
  const handleOpenModal = () => {
    setshowModal(true);
  };
  const handlePreviewClose = () => {
    setshowModal(false);
    setloading(false);
  };
  const handlePreviewClick = () => {
    setshowModal(true);
  };
  const handleContinue = () => {
    navigate("/account_closure/approved");
  };

  return (
    <div className={ESignStyles.mainWrapperTop}>
      <SnackBar message={ErrorMessage} />
      <ErrorSnackBar message={rejectMessage} />

      <div className={ESignStyles.wrapper}>
        {showModal && (
          <div
            className={ESignStyles.back}
            onClick={() => {
              if (showModal) {
                setshowModal(false);
              } else {
                navigate("/account_closure/cmr_upload");
              }
            }}
          >
            <img src={backicon} />{" "}
            <span className={ESignStyles.backText}>Back</span>
          </div>
        )}

        {showModal ? (
          <p className={ESignStyles.almostThereText}>Esign Preview</p>
        ) : (
          <div className={ESignStyles.step}>
            <img src={keyboardicon} /> Step 3 of 3
          </div>
        )}
        {showModal ? (
          ""
        ) : (
          <div className={ESignStyles.titleSection}>
            <p className={ESignStyles.almostThereText}>Almost There!</p>

            <p className={ESignStyles.title}>
              {" "}
              Digitally sign your application
            </p>
          </div>
        )}
        {!showModal ? (
          <div className={ESignStyles.container}>
            <div className={ESignStyles.leftcontainer}>
              <div>
                <div className={ESignStyles.textdiv}>
                  <p className={ESignStyles.instructiontext}>
                    <DoneOutlinedIcon style={{ color: "#049981" }} /> Click on
                    the E-Sign Button Below..
                  </p>
                  <p className={ESignStyles.instructiontext}>
                    <DoneOutlinedIcon style={{ color: "#049981" }} /> Enter Your
                    Aadhaar Number.
                  </p>
                  <p className={ESignStyles.instructiontext}>
                    <DoneOutlinedIcon style={{ color: "#049981" }} /> Enter the
                    OTP sent to your registered mobile number.
                  </p>
                </div>

                {/* <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <TextField
                    className={ESignStyles.textfield}
                    id="outlined-basic"
                    label="Reason for account closure"
                    variant="outlined"
                    name="motherFullName"
                    value={accountClosureReason}
                    onChange={(event: any) => {
                      setAccountClosureReason(event.target.value);
                    }}
                    inputProps={{
                      sx: {
                        "&::label": {
                          fill: "#111827",
                          fontWeight: 500,
                        },
                        color: "var(--Black-Black-500, #6B7280)",
                        fontSize: "14px",
                      },
                      maxLength: 50,
                      inputMode: "text",
                    }}
                    sx={{
                      fieldset: {
                        borderColor: "#E5E7EB",
                        borderRadius: "100px",
                        height: "60px",
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        color: "#6B7280",
                        fontWeight: 500,
                        "&.MuiFormLabel-filled": {
                          color: "#111827", // Label color when the field has a value
                        },
                      },
                    }}
                  />
                </div> */}
                <>
                  <div className={ESignStyles.buttonStyles}>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {continueOption ? (
                        <LoadingButton
                          type="submit"
                          variant="contained"
                          onClick={() => {
                            FillEsignPdf();
                          }}
                          loading={loading}
                          id="aadharOpenLinkButton"
                          className={ESignStyles.esignButton}
                          sx={{ width: "187px", height: "50px" }}
                        >
                          Esign Now
                        </LoadingButton>
                      ) : (
                        <>
                          <div className={ESignStyles.sectionButton}>
                            <LoadingButton
                              className={ESignStyles.continue}
                              type="submit"
                              variant="contained"
                              sx={{ width: "187px", height: "50px" }}
                              onClick={handleContinue}
                              loading={loading}
                              id="aadharOpenLinkButton"
                            >
                              Continue
                            </LoadingButton>
                            <Button
                              className={ESignStyles.esignPreview}
                              type="submit"
                              variant="outlined"
                              sx={{
                                color: "rgba(18, 183, 106, 1)",
                                borderRadius: "20px",
                              }}
                              onClick={handlePreviewClick}
                              id="aadharOpenLinkButton"
                            >
                              View E-sign Document
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        ) : (
          <div className={ESignStyles.modalContainer}>
            <div className={ESignStyles.pdfMobilePreview}>
              <img
                src={esignImage}
                style={{
                  width: "95%",
                  height: "100%",
                  objectFit: "inherit",
                  // filter: "brightness(80%)",
                  border: "5px solid #525659",
                  marginBottom: "20px",
                }}
              />
            </div>
            <div className={ESignStyles.pdfDesktopPreview}>
              <PDFViewerIframeEsign urldata={pdfUrl} />
            </div>
            <Stack marginTop={"20px"} direction={"row"}>
              <LoadingButton
                loading={esignLoading}
                variant="contained"
                sx={{
                  width: { xs: "150px", sm: "187px" },
                  margin: "auto",
                  height: "50px",
                }}
                onClick={handleOpenClick}
              >
                Continue
              </LoadingButton>
              <a
                href={pdfUrl}
                download="Esign-PDF-document"
                target="_blank"
                rel="noreferrer"
                className={ESignStyles.previewdownlaodesign}
              >
                <Button
                  variant="outlined"
                  sx={{
                    color: "#1F2937",
                    height: "50px",
                  }}
                >
                  View Esign PDF
                </Button>
              </a>
            </Stack>
          </div>
        )}
      </div>
    </div>
  );
}

export default AccountClosureEsign;
